
// const BASE_URL = 'http://8.142.121.214:20000';
//线上配置
const BASE_URL = '';
export default BASE_URL
